<template>
  <div>
    <Filters
      :status="currentStatus"
      @change="updateFilters"
    />

    <Table
      :items="items"
      :pagination="pagination"
      :status="currentStatus"
      :drawerVisibility="drawerVisibility"
      @reloadData="reloadData"
      @goToPage="updatePage"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isArray } from 'utils/functions'
import Filters from './Filters'
import Table from './Table'

export default {
  name: 'PendingPayments',
  components: {
    Filters,
    Table
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.PaymentStatusPage',
      pagination: {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      },
      filters: {
        search: null,
        status: null,
        updateDate: null,
        massiveUpdate: false
      },
      currentStatus: null,
      items: [],
      selectedItem: null,
      drawerVisibility: true
    }
  },

  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidArray (val) {
      return isArray(val)
    },

    updatePagination (response, itemsPerPage) {
      this.pagination = {
        ...this.pagination,
        totalElements: response.totalElements,
        totalPages: response.totalPages
      }
    },

    resetPagination () {
      this.pagination = {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      }
    },

    updateFilters (filters) {
      this.filters = { ...filters }
      this.reloadData()
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.loadData()
    },

    isCPNJValue (str) {
      return str && str.length === 18 && /\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}/.test(str)
        ? str.replace(/[-./]/g, '')
        : str
    },

    async loadData () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const { currentPage, itemsPerPage } = this.pagination
        const company = this.selectedCompany ? this.selectedCompany.id : null
        const { search, status, updateDate, massiveUpdate } = this.filters
        const { data: res } = await this.$apiService.getOrdersByFilter(
          { page: currentPage - 1 },
          { limit: itemsPerPage },
          { orderBy: 'desc' },
          { company },
          { search: this.isCPNJValue(search) },
          { status },
          { updateDate },
          { massiveUpdate }
        )

        if (res && !res.valid) {
          throw new Error()
        }

        this.items = res && this.isValidArray(res.content) ? res.content : []
        this.updatePagination(res, itemsPerPage)
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    }
  },

  watch: {
    selectedCompany () {
      this.reloadData()
    },

    filters: {
      deep: true,
      handler () {
        this.drawerVisibility = !this.drawerVisibility
      }
    }
  },

  mounted () {
    this.loadData()
  }
}
</script>
